// write the boiler plate code
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { sdSupportSearchBaseURL, getSearchResultsURL,getNewsRoomfacet } from '../../constants/index';
import axios from 'axios';


const initialState = {
    loading: false,
    error: '',
    newsData: [],
    filters: {},
    total: 0
};


export const getNewsRoomData = createAsyncThunk('newsRoomSlice/getNewsRoomData', async (query) => {
    try {
        return await axios.get(sdSupportSearchBaseURL + query, {
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        }).then(response => response.data);

    } catch (error) {
        throw Error('Failed to fetch search results');
    }
});


export const getSingleSegmentData = createAsyncThunk('newsRoomSlice/getSingleSegmentData', async (query) => {
    try {
        return await axios.get(getSearchResultsURL + query, {
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        }).then(response => response.data);

    } catch (error) {
        throw Error('Failed to fetch search results');
    }
})

export const getNewsRoomFacets = createAsyncThunk('newsRoomSlice/getNewsRoomFacets', async (query) => {
    try {
        return await axios.get(getNewsRoomfacet + query, {
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        }).then(response => response.data);

    } catch (error) {
        throw Error('Failed to fetch search results');
    }
})

const newsRoomSlice = createSlice({
    name: 'newsRoomSlice',
    initialState,
    reducers: {
        resetNewsRoomData: (state) => {
            state.newsData = [];
            state.total=[]
        },
    },
    extraReducers: (builder) => {
        builder.addCase(getNewsRoomData.pending, (state) => {
            state.loading = true;
        })
            .addCase(getNewsRoomData.fulfilled, (state, action) => {
                state.loading = false;
                let data=action.payload.grouped_docs;
                if(data['Press Release'] && data['Press Release'].length>0){
                    state.newsData.push({'Press Release':data['Press Release'][0]})
                }
                if(data['Blogs'] && data['Blogs'].length>0){
                    state.newsData.push({'Blogs':data['Blogs'][0]})
                }
                // state.newsData = action.payload.grouped_docs;
                state.total = action.payload.total;
            })
            .addCase(getNewsRoomData.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })
            .addCase(getSingleSegmentData.pending, (state) => {
                state.loading = true;
            })
            .addCase(getSingleSegmentData.fulfilled, (state, action) => {
                state.loading = false;
                state.newsData = action.payload?.response?.docs;
                state.total = action.payload?.response?.numFound;
            })
            .addCase(getSingleSegmentData.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })
            .addCase(getNewsRoomFacets.pending, (state) => {
                state.loading = true;
            })
            .addCase(getNewsRoomFacets.fulfilled, (state, action) => {
                state.loading = false;
                let years=[]
                let filters=action.payload?.facet_fields
                if(filters){

                    filters[1]?.yearMonth.map((item)=>{
                        years.push(item.docType)
                    })
                    state.filters['years']=years
                }
                if(filters){

                    const uniqueTags = [
                        ...new Set(
                          filters[2]?.cqTagsName_s
                            .flatMap(item => item.docType.split(','))
                            .filter(tag => tag.trim() !== 'All')
                        )
                      ];
                      
                     state.filters['topics'] = uniqueTags;
                }

            })
            .addCase(getNewsRoomFacets.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            });
    },
});

export const {resetNewsRoomData } = newsRoomSlice.actions;

export default newsRoomSlice.reducer;
